export default "__VITE_ASSET__977c1b28__"